var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-chip',{attrs:{"color":_vm.chipColor}},[_vm._v(_vm._s(_vm.cellText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }